import { render, staticRenderFns } from "./newsthank.vue?vue&type=template&id=26774346&"
import script from "./newsthank.vue?vue&type=script&lang=js&"
export * from "./newsthank.vue?vue&type=script&lang=js&"
import style0 from "./newsthank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports